import messages from '../ethic.lang.json';

export const lang = {
	i18n: {
		messages
	},
	props: {
		lang: {
			type: String,
			required: true
		}
	},
	created() {
		this.$i18n.locale = this.lang;
	}
};
